
  const ReturnClass= {
        OutMessage: "",
        MobileNumber: "",
        EmailID: "",
        PartnerID: 0,
        ID: 0,
        PendingVerfication: 0,
        
    }
export default ReturnClass;
